import React, { useEffect } from 'react'

import { Box, HStack, Stack, Text, Textarea } from '@chakra-ui/react'
import { useFormikContext } from 'formik'
import { CircleQuestionMarkIcon } from 'lucide-react'
import { useSelector, useDispatch } from 'react-redux'

import { ReferralStaffField, ContactMethodsField } from './fields'
import { loadContactMethods } from '../../../../redux/features/contactMethodsSlice'
import { FormField, Person } from '../../../ui'

const IntakeInfoPage = () => {
  const { values, setFieldValue } = useFormikContext()
  const dispatch = useDispatch()
  const contactMethods = useSelector(state =>
    (state.contactmethods.data.results || []).filter(cm => cm.is_active)
  )

  useEffect(() => {
    dispatch(loadContactMethods())
  }, [dispatch])

  const selectedMethods = values.contact_methods?.map(m => m.name) || []

  return (
    <Stack gap={3}>
      <Box>
        <Text as='b' mb={1} display='block'>
          Intake By
        </Text>
        <Person name={values.intake_staff?.full_name} />
        <Text as='b' mt={3} mb={1} display='block'>
          Contact Method(s)
        </Text>
        <ContactMethodsField
          contactMethods={contactMethods}
          selectedMethods={selectedMethods}
          values={values}
          setFieldValue={setFieldValue}
        />
      </Box>

      <Box>
        <Text as='b' mb={1} display='block'>
          Reference Numbers
        </Text>
        <FormField field='reference_numbers' inputType={Textarea} />
      </Box>

      <Box>
        <Text as='b' mb={1} display='block'>
          Referral By
        </Text>
        <ReferralStaffField />
      </Box>

      {/* Existing comments can be edited, but new casework will not have comments enabled */}
      {values.comments && (
        <Box>
          <Text as='b' mb={1} display='block'>
            Comments
          </Text>
          <FormField
            field='comments'
            placeholder='Record any additional comments'
            inputType={Textarea}
          />
        </Box>
      )}

      <Stack direction='row' gap={3}>
        <Box w='100%'>
          <Text as='b' mb={1} display='block'>
            Opened At
          </Text>
          <FormField field='opened_at' type='datetime-local' />
        </Box>
        <Box w='100%'>
          <Text as='b' mb={1} display='block'>
            Closed At
          </Text>
          <FormField field='closed_at' type='datetime-local' />
        </Box>
      </Stack>
      <HStack mt={8}>
        <CircleQuestionMarkIcon />{' '}
        <Text fontSize='sm' color='gray.500'>
          Looking for <i>Comments</i>? Comments was recently disabled in the
          recent update. Please use Activity to describe any additional details.
        </Text>
      </HStack>
    </Stack>
  )
}

export default IntakeInfoPage
